import React from 'react'
import Beep from '../media/Beep.mp3'
import './btnStyle.css'
const STUDYTIME = 25;
const BREAKTIMER = 5;
const SECONDS = 59;


export default class Timer extends React.Component{    
    constructor(props){
        super(props)
        this.state = {
            minutes: STUDYTIME,
            seconds:0,
            interval: Number,
            isTicking: false,
            isStudytime: true
        }
    }
    resetState = () =>{
        window.clearInterval(this.state.interval)        
        this.setState({minutes: STUDYTIME, isTicking: false, seconds: 0})
    }

    startStopTimer = () =>{
        const {isTicking} = this.state;
        if(!isTicking)
            this.setState({interval: window.setInterval(this.tick, 1000), isTicking: !isTicking })
        else
            window.clearInterval(this.state.interval)
            this.setState({isTicking: !isTicking})

        }

    tick = ()=>{
        const {minutes, seconds, isStudytime} = this.state;

        if(seconds> 0){
            this.setState({seconds: seconds-1})            
        }else{
            let min = minutes - 1
            if(min>=0){
                this.setState({minutes: min, seconds: SECONDS})
            }
            else{
                if(isStudytime)
                {
                    this.setState({isStudytime: !isStudytime, minutes: BREAKTIMER})
                    this.playsound();
                }
                else
                    this.setState({isStudytime: !isStudytime, minutes: STUDYTIME})
                    this.playsound();
            }
            
        }
    }

    playsound(){
        this.player.src = Beep
        this.player.play();
    }
    
    componentDidMount(){
        document.addEventListener('keydown',this.keydownHandler);
    }

    componentWillUnmount(){
        document.removeEventListener('keydown',this.keydownHandler);
    }

    keydownHandler = (e)=>{
        switch(e.keyCode){
            case 80: //P
                // console.log("ppp")
                this.startStopTimer()
                break
            case 82: //r
                // console.log("sss")
                this.resetState()
                break;
            default: 
                // console.log("key not set")
            }
        
    }
   
    render(){
        const titleStyle = {
            fontSize: "24px",
            color: "white"
        }
        const {minutes, seconds, isTicking, isStudytime} = this.state;
        return(
            <>
            <span style={titleStyle}>{isStudytime ? "Study....✍": "Take a Break 🛌"} </span>
            <div className="timerDivStyle">
               
                <div className="time">{minutes < 10 ? '0'+minutes: minutes} : {seconds< 10 ? '0'+ seconds : seconds}</div>
                {/* <button onClick={this.btnStartPause}>{isRunning ? "pause": "play"}</button> */}
            </div>

            <div className="timer-control" style={this.timeControlDovStyle}>
                <button
                    className="btnStyle passiveBtnColor" 
                    onClick={this.startStopTimer}>
                    {isTicking ? "Pause" : "Play"}
                </button>
                <button onClick={this.resetState} className="btnStyle stopBtnStyle">Reset</button>
            </div>
            <audio ref={ref => this.player = ref}/>
            </>
        )
    }
}